import { useQuery } from "react-query";
import { getContactConfig } from "../../../api/services/contacts/config";

export const useContactConfig = () => {
  return useQuery("contacts/config", getContactConfig);
};
